export default __webpack_public_path__ + "static/media/asbestosL1.96384ed4.png";